import { render } from "./ProposalPageLeftSideNav.vue?vue&type=template&id=7a2c8388&scoped=true&ts=true"
import script from "./ProposalPageLeftSideNav.vue?vue&type=script&lang=ts"
export * from "./ProposalPageLeftSideNav.vue?vue&type=script&lang=ts"

import "./ProposalPageLeftSideNav.vue?vue&type=style&index=0&id=7a2c8388&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2c8388"]])

export default __exports__